{
  "forms": {
    "save": "Save",
    "cancel": "Cancel",
    "add": "Add",
    "update": "Update",
    "edit": "Edit",
    "delete": "Delete",
    "confirm": "Confirm",
    "continue": "Continue",
    "submit": "Submit",
    "create": "Create",
    "search": "Search",
    "search_placeholder": "Search...",
    "select": "Select",
    "clear": "Clear",
    "reset": "Reset",
    "apply": "Apply"
  },
  "nav": {
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "close": "Close",
    "open": "Open",
    "refresh": "Refresh",
    "first_page": "first page",
    "previous_page": "previous page",
    "next_page": "next page",
    "last_page": "last page"
  },
  "status": {
    "loading": "Loading...",
    "saving": "Saving...",
    "deleting": "Deleting...",
    "updating": "Updating...",
    "processing": "Processing...",
    "success": "Success",
    "error": "Error",
    "warning": "Warning",
    "info": "Info",
    "not_found": "Not Found",
    "items_selected": "Items Selected"
  },
  "state": {
    "loading": "Loading"
  },
  "actions": {
    "title": "Actions",
    "view": "View",
    "download": "Download",
    "upload": "Upload",
    "import": "Import",
    "export": "Export",
    "remove": "Remove",
    "share": "Share",
    "archive": "Archive",
    "show_more": "Show More",
    "show_less": "Show Less",
    "show_all": "Show All",
    "filters": {
      "title": "Filters",
      "filter": "Filter",
      "clear_filter": "Clear filter",
      "remove_filter": "Remove filter",
      "more_filters": "More filters",
      "add_filter": "Add Filter",
      "is": "is",
      "one_of": "one of",
      "and": "and",
      "value_label": "Value",
      "value_placeholder": "Value",
      "operators": {
        "contains": "contains",
        "does_not_contain": "does not contain",
        "ends_with": "ends with",
        "has_any_value": "has any value",
        "has_no_value": "has no value",
        "is": "is",
        "is_not": "is not",
        "is_one_of": "is one of",
        "starts_with": "starts with",
        "unknown_operator": "unknown operator"
      }
    },
    "restore": "Restore",
    "duplicate": "Duplicate",
    "rename": "Rename"
  },
  "confirmation": {
    "are_you_sure": "Are you sure?",
    "cannot_be_undone": "This action cannot be undone.",
    "confirm_delete": "Are you sure you want to delete this?",
    "confirm_archive": "Are you sure you want to archive this?",
    "click_confirm": "Click confirm to continue",
    "click_confirm_to_delete": "Click confirm to delete"
  },
  "errors": {
    "context_provider_required": "useZIndex must be used within a ZIndexProvider"
  },
  "accessibility": {
    "info_tooltip": "{{label}} info"
  },
  "icons": {
    "key_contact": "key contact",
    "has_phone_number": "has phone number"
  },
  "priority": {
    "none": "none",
    "low": "low",
    "medium": "medium",
    "high": "high",
    "critical": "critical"
  }
}
